import PropTypes from 'prop-types';
import { useState, useCallback } from 'react';
// @mui
import {Box, Chip, Stack, ListItem, List, ListItemButton, ListItemIcon, ListItemText, Typography, Drawer, Button} from '@mui/material';
import { useSelector } from 'react-redux';
// utils
import { fData } from 'src/util/format-number';
import { fDateTime } from 'src/util/formatTime';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import Iconify from 'src/components/iconify';
import Scrollbar from 'src/components/scrollbar';
import FileThumbnail, { fileFormat } from 'src/components/file-thumbnail';
//
// import FileManagerShareDialog from './file-manager-share-dialog';
// import FileManagerInvitedItem from './file-manager-invited-item';

// ----------------------------------------------------------------------



export default function FileManagerFileDetails({
  item,
  open,
  favorited,
  //
  onFavorite,
  onCopyLink,
  onClose,
  onDelete,
  ...other
}) {
   const { name, files, sharedBy, modifiedDate, isIndividual } = item; 
 const company = useSelector((state) => state?.auth?.company);
const renderFile = (
    <>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ p: 2.5 }}>
        <Typography variant="subtitle2"> Files </Typography>
      </Stack>
    <List>
      {
        files?.map((res) => (
          <ListItem>
            <ListItemButton
                 href={res?.url}
      target="_blank"
      rel="noopener noreferrer">
              <ListItemIcon>
                <FileThumbnail file={res?.type} sx={{ width: 36, height: 36 }} />
              </ListItemIcon>
              <ListItemText primary={res?.name} 
                secondary={`Size: ${fData(res?.size)}`}
              />
            </ListItemButton>
          </ListItem>
        ))
      }
    </List>
    
    </>
  );

  return (
    <>
      <Drawer
        open={open}
        onClose={onClose}
        anchor="right"
        slotProps={{
          backdrop: { invisible: true },
        }}
        PaperProps={{
          sx: { width: 420 },
        }}
        {...other}
      >
        <Scrollbar sx={{ height: 1 }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ p: 2.5 }}>
            <Typography variant="h6">Folder Info </Typography>
          </Stack>

          <Stack
            spacing={2.5}
            justifyContent="center"
            sx={{
              p: 2.5,
              bgcolor: 'background.neutral',
            }}
          >
            <FileThumbnail file={'folder'} sx={{ width: 56, height: 56 }} />
           <Typography variant="subtitle1" sx={{ wordBreak: 'break-all' }}>
              {name}
            </Typography>



          </Stack>

          {renderFile}
        </Scrollbar>

                  <Button variant='contained' color='primary' onClick={onClose}>Close</Button>
      </Drawer>

      {/* <FileManagerShareDialog
        open={share.value}
        shared={shared}
        inviteEmail={inviteEmail}
        onChangeInvite={handleChangeInvite}
        onCopyLink={onCopyLink}
        onClose={() => {
          share.onFalse();
          setInviteEmail('');
        }}
      /> */}

    </>
  );
}

FileManagerFileDetails.propTypes = {
  favorited: PropTypes.bool,
  item: PropTypes.object,
  onClose: PropTypes.func,
  onCopyLink: PropTypes.func,
  onDelete: PropTypes.func,
  onFavorite: PropTypes.func,
  open: PropTypes.bool,
};
